import { snakeToTitleCase } from 'lib/helpers/utility';

const MAX_DISPLAY_LENGTH = 120;
const BLOB_CHARACTERS = /[{}[\]"]/;
const CODE_STYLE = /^[A-Z0-9_ ]+$/;

export const toDisplayPaymentMessage = (raw, fallback) => {
  if (typeof raw !== 'string') return fallback;

  const message = raw.trim();
  if (!message || message.length > MAX_DISPLAY_LENGTH) return fallback;
  if (BLOB_CHARACTERS.test(message) || message === '[object Object]') return fallback;

  return CODE_STYLE.test(message) ? snakeToTitleCase(message.toLowerCase()) : message;
};
